// extracted by mini-css-extract-plugin
export default {"button":"style_button__aqvY6","active":"style_active__cC7ob","left":"style_left__rwqAT","right":"style_right__HITE3","num":"style_num__JjjxG"};